import { encryptRequest, decryptResponse } from "./cryptoHelper";
import { apiPost } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const askToQRobotFromAPI = async (token, obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPost('/qrobot', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};
